import { VStack } from '@vivaahealth/design-system';
import { useTranslation } from 'react-i18next';

import * as api from '../../../api';
import TextData from '../../../components/TextData';

interface FamilyMedicalHistoryProps {
  field: api.PrevisitFormField.PrevisitFormFieldWithConfig;
}

const FamilyMedicalHistory = ({ field }: FamilyMedicalHistoryProps) => {
  const { t } = useTranslation('review');

  const { conditions } = JSON.parse(
    field.value,
  ) as api.FamilyMedicalHistory.FamilyMedicalHistory;

  return (
    <VStack gap={16}>
      {conditions.map(({ condition, relationship }) => (
        <TextData
          key={condition}
          label={t(
            api.Previsit.familyRelationshipsMap[relationship[0] || 'OTHER'],
          )}
          value={t(condition)}
        />
      ))}
    </VStack>
  );
};

export default FamilyMedicalHistory;
